const textTenagaKesehatan = {
	TENAGA_KESEHATAN: {
		PAGE_GREETING: 'Tenaga Kesehatan',
		PAGE_GREETING_DESC: 'Silakan lengkapi data berikut dan sertakan tujuan kerja sama',
	},
	ALPHABET: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
};

export default textTenagaKesehatan;
